import { IconButton, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatPopup.css';
import { IOffer } from '../../types/offerData';

interface IChatPopupProps {
  offer: IOffer;
  gaLabel?: string;
  gaProducts?: string;
  defaultMessage?: string;
  messagePayload?: string;
  shouldSendDefaultMessage?: boolean;
  source?: string | null;
  isChatbot: boolean;
  isConsultantChat: boolean;
  chatId: string | null;
  regionId: number;
  onClose(): void;
  isEarlyAccess?: boolean;
}

export const ChatPopup: React.FC<IChatPopupProps> = ({
  offer,
  onClose,
  gaProducts,
  gaLabel,
  defaultMessage,
  messagePayload,
  shouldSendDefaultMessage,
  source,
  isChatbot,
  isEarlyAccess,
  isConsultantChat,
  chatId,
  regionId,
}) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  let src: string;

  const { id, cianId, dealType, offerType } = offer;

  if (isChatbot) {
    src =
      `/dialogs/?hostType=frame&chatbot=1&defaultMessagePayload=${id}` +
      `${cianId ? `&cianId=${cianId}` : ''}` +
      `${gaProducts ? '&gaProducts=' + encodeURIComponent(gaProducts) : ''}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      `&source=Card&pageType=Card` +
      `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
      `${source ? `&parentSource=${source}` : ''}`;
  } else if (isConsultantChat && chatId) {
    src =
      `/dialogs/?hostType=frame&type=bot&chatId=${chatId}&region=${regionId}` +
      `${cianId ? `&cianId=${cianId}` : ''}` +
      `${gaProducts ? '&gaProducts=' + encodeURIComponent(gaProducts) : ''}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      `&source=Card&pageType=Card` +
      `${source ? `&parentSource=${source}` : ''}`;
  } else {
    /* istanbul ignore next */
    src =
      `/dialogs/?hostType=frame&offerId=${id}` +
      `${cianId ? `&cianId=${cianId}` : ''}` +
      `&dealType=${dealType}&offerType=${offerType}` +
      `${gaProducts ? '&gaProducts=' + encodeURIComponent(gaProducts) : ''}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
      `${messagePayload ? '&defaultMessagePayload=' + encodeURIComponent(messagePayload) : ''}` +
      '&pageType=Card' +
      `${shouldSendDefaultMessage ? '&sendDefaultMessage=1' : ''}` +
      `${isEarlyAccess ? '&isEarlyAccess=1' : ''}` +
      `${source ? `&parentSource=${source}` : ''}`;
  }

  return (
    <div className={styles['container']} data-testid={isConsultantChat ? 'ConsultantCianChatPopup' : 'ChatContainer'}>
      <span className={styles['close']} data-testid="ChatCloseButton">
        <IconButton icon={<IconActionClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe data-testid="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
    </div>
  );
};
